import React from 'react';
import { Text } from '@ui';
export function TechnicianCell({ item }) {
    return (React.createElement("div", { className: "visits-table__tech" },
        React.createElement(Text, { variant: "body" }, item.techName),
        item.techRole && (React.createElement(Text, { variant: "body", as: "i", className: "visits-table__tech-role" }, item.techRole))));
}
